module.exports = __webpack_public_path__ + "static/media/ic_config_disabled.486ab95f.svg";